import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import "./PrizesConfiguratorDisplayCard.scss";
import KC_Heading3 from "../../../../../designsystem/typography/KC-Heading/KC_Heading3";
import PrizeImage from "../PrizeImage";

export interface PrizesConfiguratorDisplayCardProps {
  title: string;
  media?: React.ReactNode;
  img?: string;
  secondaryText?: string;
  badge?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  isPrize?: boolean;
  isEditable?: boolean;
  onEdit?: () => void;
}

const PrizesConfiguratorDisplayCard = (
  props: PrizesConfiguratorDisplayCardProps
) => {
  const IMAGE = useMemo(() => {
    if (props.media) {
      return props.media;
    }
    return <PrizeImage image={props.img} />;
  }, [props.img, props.media]);

  return (
    <div
      className={`prizes-configurator-display-card ${props.className ?? ""}`.trim()}
    >
      {props.isEditable && (
        <div
          className="prizes-configurator-display-card__edit"
          onClick={props.onEdit}
        >
          <FontAwesomeIcon icon={faPen} />
        </div>
      )}
      {props.badge != null && (
        <div className="prizes-configurator-display-card__badge">
          {props.badge}
        </div>
      )}
      <div className="prizes-configurator-display-card__row">
        <div className="prizes-configurator-display-card__media">{IMAGE}</div>
        <div className="prizes-configurator-display-card__content">
          <KC_Heading3 text={props.title} />
          {props.secondaryText != null && props.secondaryText !== "" && (
            <span className="prizes-configurator-display-card__secondary">
              {props.secondaryText}
            </span>
          )}
          {props.children != null && (
            <div className="prizes-configurator-display-card__extra">
              {props.children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrizesConfiguratorDisplayCard;
